import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  propertyDetailsSkeletonPageWrapper: {
    display: 'flex',
    width: '1451px',
    minWidth: '400px',
    padding: '20px 32px',
    flexDirection: 'column',
    gap: '20px',
    backgroundColor: theme.palette.background.primary,
    border: `1px solid ${theme.palette.border.gray_200}`,
    borderRadius: '0px 12px 12px 12px',
  },
  basicInfoSekeletonSection: {
    padding: '16px',
    backgroundColor: theme.palette.background.gray_50,
    height: 'fit-content',
    width: '100%',
    border: `1px solid ${theme.palette.border.gray_200}`,
    borderRadius: '12px',
  },
  fieldWrapper: {
    display: 'flex',
    gap: '32px',
    margin: '20px 0px',
  },
  mapFieldWrapper: {
    display: 'flex',
    gap: '4px',
  },
  propertySpecificationSkeletonSection: {
    padding: '24px 32px',
    backgroundColor: theme.palette.background.gray_50,
    height: '436px',
    maxHeight: '436px',
    width: '1387px',
    maxWidth: '1387px',
    border: `1px solid ${theme.palette.border.gray_200}`,
    borderRadius: '12px',
  },
  financialInfoSkeletonSection: {
    padding: '24px 32px',
    backgroundColor: theme.palette.background.gray_50,
    height: '311px',
    maxHeight: '311px',
    width: '1387px',
    maxWidth: '1387px',
    border: `1px solid ${theme.palette.border.gray_200}`,
    borderRadius: '12px',
  },
  availabilitySkeletonSection: {
    padding: '24px 32px',
    backgroundColor: theme.palette.background.gray_50,
    height: '68px',
    maxHeight: '68px',
    width: '1387px',
    maxWidth: '1387px',
    border: `1px solid ${theme.palette.border.gray_200}`,
    borderRadius: '12px',
    display: 'flex',
    gap: '32px',
  },
  availabilitySkeletonSectionOptions: {
    display: 'flex',
    gap: '32px',
  },
}));
